export default __webpack_public_path__ + "static/media/SFCINEMA_web_details.33bfff99.png";